(function () {
  document.documentElement.classList.remove('no-js');

  function resumeAutoplayVideos() {
    if (document.visibilityState === 'hidden') return;

    document.querySelectorAll('.js-autoplay-video').forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      var playAttempt = video.play();
      if (playAttempt && typeof playAttempt.catch === 'function') {
        playAttempt.catch(function () {});
      }
    });
  }

  window.setTimeout(resumeAutoplayVideos, 250);
  window.addEventListener('pageshow', resumeAutoplayVideos);
  window.addEventListener('focus', resumeAutoplayVideos);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resumeAutoplayVideos();
  });
  document.addEventListener('shopify:section:load', resumeAutoplayVideos);

  var mobileToggle = document.querySelector('[data-mobile-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-slide]'));
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-slide-dot]'));
    var index = 0;

    function showSlide(nextIndex) {
      index = nextIndex;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        showSlide(i);
      });
    });

    if (slides.length > 1) {
      window.setInterval(function () {
        showSlide((index + 1) % slides.length);
      }, 5000);
    }
  });

  document.querySelectorAll('[data-product]').forEach(function (root) {
    var mainMedia = root.querySelector('[data-main-media]');
    root.querySelectorAll('[data-media-thumb]').forEach(function (button) {
      button.addEventListener('click', function () {
        var html = button.querySelector('template');
        if (mainMedia && html) {
          mainMedia.innerHTML = html.innerHTML;
          root.querySelectorAll('[data-media-thumb]').forEach(function (thumb) {
            thumb.classList.remove('is-active');
          });
          button.classList.add('is-active');
        }
      });
    });

    var variantRoot = root.querySelector('[data-variant-selects]');
    var variantInput = root.querySelector('[data-variant-id]');
    var productForm = root.querySelector('.product-form');
    var availability = root.querySelector('[data-availability]');
    var addToCart = root.querySelector('[data-add-to-cart]');
    var quantityControl = productForm ? productForm.querySelector('[data-quantity]') : null;
    var quantityInput = quantityControl ? quantityControl.querySelector('input') : null;
    var inventoryScript = root.querySelector('[data-product-inventory]');
    var inventoryData = { variants: [], cart_items: [] };
    try {
      inventoryData = JSON.parse(inventoryScript ? inventoryScript.textContent : '{}');
    } catch (error) {
      inventoryData = { variants: [], cart_items: [] };
    }

    function quantityInCart(variantId) {
      return (inventoryData.cart_items || []).reduce(function (total, item) {
        return Number(item.variant_id) === Number(variantId) ? total + Number(item.quantity || 0) : total;
      }, 0);
    }

    function remainingForVariant(variant) {
      if (!variant || !variant.inventory_management || variant.inventory_policy === 'continue') return null;

      var inventoryQuantity = Number(variant.inventory_quantity);
      if (!Number.isFinite(inventoryQuantity)) return null;

      return Math.max(0, inventoryQuantity - quantityInCart(variant.id));
    }

    function updateQuantityButtons(available, remaining) {
      if (!quantityControl || !quantityInput) return;

      var current = Math.max(1, Number(quantityInput.value || 1));
      if (remaining !== null) current = Math.min(current, remaining);
      if (!available) current = 1;

      quantityInput.value = current;
      quantityInput.disabled = !available;

      if (remaining !== null) {
        quantityInput.max = String(remaining);
      } else {
        quantityInput.removeAttribute('max');
      }

      quantityControl.querySelectorAll('button').forEach(function (button) {
        var delta = Number(button.getAttribute('data-quantity-change'));
        button.disabled = !available || (delta < 0 && current <= 1) || (delta > 0 && remaining !== null && current >= remaining);
      });
    }

    function updateProductState(variant) {
      var remaining = remainingForVariant(variant);
      var available = !!variant && variant.available && (remaining === null || remaining > 0);
      var lowStock = available && remaining !== null && remaining < 4;

      if (availability) {
        availability.classList.toggle('availability--sold-out', !available);
        availability.classList.toggle('availability--low-stock', lowStock);
        availability.textContent = available ? (lowStock ? 'Low Stock' : 'In Stock') : 'Out of Stock';
      }

      if (addToCart) {
        addToCart.disabled = !available;
        addToCart.textContent = available ? addToCart.getAttribute('data-add-text') : addToCart.getAttribute('data-sold-out-text');
      }

      updateQuantityButtons(available, remaining);
    }

    if (variantRoot && variantInput) {
      var variantScript = variantRoot.querySelector('script[type="application/json"]');
      var variants = inventoryData.variants || [];
      try {
        variants = variants.length ? variants : JSON.parse(variantScript ? variantScript.textContent : '[]');
      } catch (error) {
        variants = [];
      }

      variantRoot.addEventListener('change', function () {
        var selected = Array.prototype.slice.call(variantRoot.querySelectorAll('input[type="radio"]:checked')).map(function (input) {
          return input.value;
        });
        var match = variants.find(function (variant) {
          return variant.options.every(function (option, i) {
            return option === selected[i];
          });
        });
        if (match) {
          variantInput.value = match.id;
          updateProductState(match);
        }
      });
    }

    function selectedVariant() {
      var selectedId = variantInput ? Number(variantInput.value) : null;
      return (inventoryData.variants || []).find(function (variant) {
        return Number(variant.id) === selectedId;
      });
    }

    if (quantityInput) {
      quantityInput.addEventListener('change', function () {
        updateProductState(selectedVariant());
      });
      quantityInput.addEventListener('input', function () {
        updateProductState(selectedVariant());
      });
    }

    if (productForm) {
      productForm.addEventListener('submit', function (event) {
        var variant = selectedVariant();
        var remaining = remainingForVariant(variant);
        var requested = quantityInput ? Number(quantityInput.value || 1) : 1;
        if (!variant || !variant.available || (remaining !== null && requested > remaining)) {
          event.preventDefault();
          updateProductState(variant);
        }
      });
    }

    updateProductState(selectedVariant());
  });

  document.querySelectorAll('[data-quantity]').forEach(function (control) {
    var input = control.querySelector('input');
    control.querySelectorAll('button').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!input || input.disabled || button.disabled) return;
        var delta = Number(button.getAttribute('data-quantity-change'));
        var current = Number(input.value || 1);
        var next = Math.max(1, current + delta);
        var max = input.max ? Number(input.max) : null;
        if (max !== null && Number.isFinite(max)) next = Math.min(next, max);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  var popup = document.querySelector('[data-sale-popup]');
  if (popup && !sessionStorage.getItem('hasSeenWaitlistPopup')) {
    window.setTimeout(function () {
      popup.classList.add('is-visible');
      sessionStorage.setItem('hasSeenWaitlistPopup', 'true');
    }, 1500);
  }

  document.querySelectorAll('[data-popup-close]').forEach(function (button) {
    button.addEventListener('click', function () {
      var target = button.closest('[data-sale-popup]');
      if (target) target.classList.remove('is-visible');
    });
  });
  function initializeCollectionDrawers() {
    document.querySelectorAll('[data-collection-drawer]').forEach(function (drawer) {
      if (drawer.dataset.initialized) return;
      drawer.dataset.initialized = 'true';
      var trigger = document.querySelector('[aria-controls="' + drawer.id + '"]');
      if (!trigger) return;
      var previousOverflow;
      trigger.addEventListener('click', function () {
        previousOverflow = document.body.style.overflow;
        drawer.showModal();
        document.body.style.overflow = 'hidden';
      });
      drawer.querySelector('[data-collection-drawer-close]').addEventListener('click', function () {
        drawer.close();
      });
      drawer.addEventListener('click', function (event) {
        var bounds = drawer.getBoundingClientRect();
        if (event.target === drawer && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) drawer.close();
      });
      drawer.addEventListener('close', function () {
        document.body.style.overflow = previousOverflow || '';
        trigger.focus();
      });
    });
  }
  initializeCollectionDrawers();
  document.addEventListener('shopify:section:load', initializeCollectionDrawers);
})();
